import { PlatformState } from './types';

export const getPortalDomain = (state: any): PlatformState['portalDomain'] => state.platform.portalDomain;
export const hostUrlSelector = (state: any): PlatformState['hostUrl'] => state.platform.hostUrl;
export const getBynderAccessToken = (state: any): PlatformState['bynderAccessToken'] =>
    state.platform.bynderAccessToken;
export const isAppInitializingSelector = (state): PlatformState['isAppInitializing'] =>
    state.platform.isAppInitializing;
